// extracted by mini-css-extract-plugin
export var clauseRow = "_bw-6";
export var emptyState = "_bw-d";
export var filterContent = "_bw-a";
export var filterGroup = "_bw-1";
export var filterGroupContainer = "_bw-0";
export var nestedGroup = "_bw-2";
export var nestedGroupContent = "_bw-b";
export var nestedGroupDepth1 = "_bw-3";
export var nestedGroupDepth2 = "_bw-4";
export var nestedGroupDepth3 = "_bw-5";
export var nestedGroupEmpty = "_bw-c";
export var operatorAnd = "_bw-8";
export var operatorOr = "_bw-9";
export var operatorToggle = "_bw-7";
export var removeGroupButton = "_bw-e";